export default function NotFound() {
  return (
    <div
      style={{
        alignItems: 'center',
        display: 'flex',
        height: '100%',
        justifyContent: 'center',
        width: '100%',
      }}
    >
      <h1>404 Not Found</h1>
    </div>
  )
}
